import { __assign } from "tslib";
import React from 'react';
import { Card } from '@keen.io/ui-core';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { Container, Header } from './error.widget.styles';
import text from './text.json';
import WidgetHeading from '../widget-heading.component';
var ErrorWidget = function (_a) {
    var card = _a.card, title = _a.title, subtitle = _a.subtitle, message = _a.message, _b = _a.header, header = _b === void 0 ? text.renderError : _b;
    return (React.createElement(Card, __assign({}, card),
        React.createElement(WidgetHeading, { title: title, subtitle: subtitle }),
        React.createElement(Container, null,
            React.createElement(Header, null, header),
            React.createElement(BodyText, { variant: "body1", color: colors.red[500] }, message))));
};
export default ErrorWidget;
